import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const TransferTypeFragment = gql`
    fragment TransferType on settings_transfer_type {
        ${EntityFields}
        ${EnumFields}
    }
`
